import styled from 'styled-components';

export const StyledBIMonitor = styled.div`
    padding: 2rem;
`;
